import { render } from "./ProjectCreate.vue?vue&type=template&id=6ad25d26&scoped=true"
import script from "./ProjectCreate.vue?vue&type=script&lang=js"
export * from "./ProjectCreate.vue?vue&type=script&lang=js"

import "./ProjectCreate.vue?vue&type=style&index=0&id=6ad25d26&lang=scss&scoped=true"

import exportComponent from "/var/www/html/double-daywrap-newsystem-php/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ad25d26"]])

export default __exports__